import { Avatar, Dropdown, type MenuProps } from 'antd';
import { useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth/use-auth';
import { initials } from '@/lib/utils/format';

/** Account menu (Ant Dropdown) with the same aria-label the e2e helpers wait for after sign-in. */
export function UserMenu() {
  const { profile, role, signOut } = useAuth();
  const navigate = useNavigate();
  if (!profile) return null;
  const items: MenuProps['items'] = [
    { key: 'head', disabled: true, label: <div className="user-menu-head"><div className="user-menu-name">{profile.name}</div><div className="user-menu-role">{role === 'admin' ? 'Administrator' : 'Technician'} · {profile.email}</div></div> },
    { type: 'divider' },
    { key: 'profile', label: 'My profile', onClick: () => navigate('/profile') },
    { key: 'password', label: 'Change password', onClick: () => navigate('/change-password') },
    { type: 'divider' },
    { key: 'signout', label: 'Sign out', danger: true, onClick: async () => { await signOut(); navigate('/sign-in', { replace: true }); } },
  ];
  return (
    <div className="user-menu">
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
        <button type="button" className="user-avatar" aria-label={`Account menu for ${profile.name}`} aria-haspopup="menu">
          <Avatar size={32} style={{ background: '#07843D', fontWeight: 600 }}>{initials(profile.name)}</Avatar>
        </button>
      </Dropdown>
    </div>
  );
}
